const noop = () => {
  // This is intentional
};

export default noop;
